import { render, staticRenderFns } from "./ExistingCartItems.vue?vue&type=template&id=2982c2a4&scoped=true&"
import script from "./ExistingCartItems.vue?vue&type=script&lang=js&"
export * from "./ExistingCartItems.vue?vue&type=script&lang=js&"
import style0 from "./ExistingCartItems.vue?vue&type=style&index=0&id=2982c2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2982c2a4",
  null
  
)

export default component.exports